function filledHeartSvg() {
  return `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_468_82)">
<path d="M1 9.45895C1 14.8261 5.422 17.6857 8.6582 20.2463C9.8 21.1491 10.9 22 12 22C13.1 22 14.2 21.1502 15.3418 20.2452C18.5791 17.6868 23 14.8261 23 9.46005C23 4.09399 16.95 0.28521 12 5.44599C7.05 0.28521 1 4.09178 1 9.45895Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_468_82">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

  `;
}

function emptyHeartSvg() {
  return `
   <?xml version="1.0" encoding="utf-8"?> <!-- License: CC Attribution. Made by thewolfkit: https://www.figma.com/@thewolfkit --> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 8.5C1 5.21475 3.31333 2 7 2C8.70883 2 9.92877 2.48125 10.8649 3.2079C11.3091 3.55266 11.6802 3.94929 11.9974 4.33639C12.311 3.95011 12.6785 3.55357 13.1186 3.20977C14.0531 2.47979 15.275 2 17 2C20.7289 2 23 5.22013 23 8.5C23 11.8412 21.3259 14.6994 19.2285 16.9297C17.1279 19.1634 14.523 20.8565 12.4472 21.8944C12.1657 22.0352 11.8343 22.0352 11.5528 21.8944C9.47698 20.8565 6.8721 19.1634 4.77151 16.9297C2.67415 14.6994 1 11.8412 1 8.5ZM7 4C4.68667 4 3 6.02986 3 8.5C3 11.1445 4.32585 13.5363 6.22849 15.5596C7.9833 17.4256 10.1612 18.9027 12 19.8754C13.8388 18.9027 16.0167 17.4256 17.7715 15.5596C19.6741 13.5363 21 11.1445 21 8.5C21 6.02448 19.3463 4 17 4C15.6874 4 14.907 4.35067 14.3497 4.78592C13.8333 5.18934 13.4736 5.68102 13.045 6.26703C12.9669 6.37374 12.8866 6.48357 12.8026 6.59656C12.6139 6.85039 12.3163 7 12 7C11.6837 7 11.3861 6.85039 11.1974 6.59656C11.1256 6.49997 11.0562 6.4055 10.9884 6.31318C10.5465 5.71179 10.1717 5.20159 9.63856 4.78779C9.07355 4.34922 8.29117 4 7 4Z" fill="#000000"/> </svg>
  `;
}

function updateWishlistCount() {
  const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  const count = wishlistData.length;
  const wishlistCountElements = document.querySelectorAll('.wishlist-count');
  wishlistCountElements.forEach((element) => {
    element.textContent = count;
  });
  const wishlistLinks = document.querySelectorAll('.wishlist-count');
  wishlistLinks.forEach((link) => {
    link.setAttribute('data-count', count);
  });
}

function toggleWishlist(button) {
  const pdpData = {
    productTitle: button.dataset.title,
    productImg: button.dataset.img,
    productPrice: button.dataset.price,
    productUrl: button.dataset.url,
    productId: button.dataset.id,
    productVendor: button.dataset.vendor,
    productVariantid: button.dataset.variantid,
    productAvailable: button.dataset.available,
  };

  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

  const isAlreadyInWishlist = wishlistData.some(
    (item) => item.productId === pdpData.productId
  );

  if (!isAlreadyInWishlist) {
    wishlistData.push(pdpData);

    localStorage.setItem('wishlist', JSON.stringify(wishlistData));

    button.innerHTML = filledHeartSvg();
  } else {
    wishlistData = wishlistData.filter(
      (item) => item.productId !== pdpData.productId
    );

    localStorage.setItem('wishlist', JSON.stringify(wishlistData));

    button.innerHTML = emptyHeartSvg();
  }
  updateWishlistCount();
  displayWishlist();
}

function removeFromWishlist(productId) {
  let wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];
  wishlistData = wishlistData.filter(
    (item) => item.productId !== productId
  );
  localStorage.setItem('wishlist', JSON.stringify(wishlistData));
  updateWishlistCount();
  displayWishlist();
}

function displayWishlist() {
  const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

  const wishlistBlock = document.querySelector(
    '.templatesuffix--wishlist .js-wishlistBlock'
  );

  if (!wishlistBlock) return;

  if (wishlistData.length === 0) {
    wishlistBlock.innerHTML = `<p>Wishlist is empty</p>`;
    return;
  }

  const wishlistHtml = wishlistData
    .map(
      (item) => `
      <li class="grid__item scroll-trigger animate--slide-in">
        <div class="wishlist-product__list card-wrapper product-card-wrapper underline-links-hover">

          <button
            class="wishlist-btn wishlist_button"
            aria-label="Wishlist"
            data-title="${item.productTitle}"
            data-img="${item.productImg}"
            data-price="${item.productPrice}"
            data-url="${item.productUrl}"
            data-id="${item.productId}"
            data-vendor="${item.productVendor}"
            data-variantid="${item.productVariantid}"
            data-available="${item.productAvailable}"
          >
            ${filledHeartSvg()}
          </button>

          <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">

            <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100.0%;">

              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img
                    src="${item.productImg}"
                    alt="${item.productTitle}"
                    class="motion-reduce"
                    width="1200"
                    height="1200"
                  >
                </div>
              </div>

              <div class="card__content">
                <div class="card__information">

                  <h3 class="card__heading">
                    <a href="${item.productUrl}" class="full-unstyled-link">
                      ${item.productTitle}
                    </a>
                  </h3>

                </div>
              </div>

            </div>

            <div class="card__content">
              <div class="card__information">

                <h3 class="card__heading h5">
                  <a href="${item.productUrl}" class="full-unstyled-link">
                    ${item.productTitle}
                  </a>
                </h3>

                <div class="card-information">
                  <div class="price_block">

                    <div class="quick-add no-js-hidden">
                      <product-form>
                        
                          <input type="hidden" name="form_type" value="product" />
                          <input type="hidden" name="utf8" value="✓" />
                          
                          <input
                            type="hidden"
                            name="id"
                            value="${item.productVariantid}"
                            class="product-variant-id"
                            ${item.productAvailable === 'false' ? 'disabled' : ''}
                          />

                          <button
                            type="submit"
                            name="add"
                            class="cart_btn quick-add__submit button button--full-width button--secondary"
                            aria-haspopup="dialog"
                            aria-live="polite"
                            data-sold-out-message="true"
                            ${item.productAvailable === 'false' ? 'disabled' : ''}
                          >
                            <span>${item.productAvailable === 'true'? 'Add to cart': 'Sold out' }</span>

                            <div class="loading__spinner hidden">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="spinner"
                                viewBox="0 0 66 66"
                              >
                                <circle
                                  stroke-width="6"
                                  cx="33"
                                  cy="33"
                                  r="30"
                                  fill="none"
                                  class="path"
                                ></circle>
                              </svg>
                            </div>
                          </button>

                          <input
                            type="hidden"
                            name="product-id"
                            value="${item.productId}"
                          />
                        
                      </product-form>
                    </div>

                    <div class="price">
                      <div class="price__container">

                        <div class="price__regular">
                          <span class="price-item price-item--regular">
                            ${item.productPrice}
                          </span>
                        </div>

                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </li>
    `
    )
    .join('');

  wishlistBlock.innerHTML = wishlistHtml;

  bindWishlistButtons();
}

function updateWishlistButtons() {
  const wishlistData = JSON.parse(localStorage.getItem('wishlist')) || [];

  const wishlistButtons = document.querySelectorAll('.wishlist_button');

  wishlistButtons.forEach((wishlistButton) => {
    const productId = wishlistButton.dataset.id;

    const isAlreadyInWishlist = wishlistData.some(
      (item) => item.productId === productId
    );

    wishlistButton.innerHTML = isAlreadyInWishlist
      ? filledHeartSvg()
      : emptyHeartSvg();
  });
}

function bindWishlistButtons() {
  const wishlistButtons = document.querySelectorAll('.wishlist_button');

  wishlistButtons.forEach((button) => {
    button.removeEventListener('click', wishlistClickHandler);
    button.addEventListener('click', wishlistClickHandler);
  });
}

function wishlistClickHandler() {
  toggleWishlist(this);
}

document.addEventListener('DOMContentLoaded', function () {
  updateWishlistButtons();
  displayWishlist();
  bindWishlistButtons();
  updateWishlistCount();
});